export default __webpack_public_path__ + "static/271-d25d6901de3a41bbac8154f716520c92.gif";